import { Button, Result } from "antd-v5";
import React from "react";

const Page403: React.FC = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button href="/#" type="primary">
          Back Home
        </Button>
      }
    />
  );
};

export default Page403;
